// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_24wQ57","pin":"_2hB-6p","pin-center":"Blit1V","map":"E-k2gE"};